import { render } from "./IconTable.vue?vue&type=template&id=6f1acd62"
import script from "./IconTable.vue?vue&type=script&lang=js"
export * from "./IconTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__